
import { Component, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BoardsService } from 'src/app/service/boards.service';
import { Location } from '@angular/common';


@Component({
  selector: 'app-edit-onetime',
  templateUrl: './edit-onetime.component.html',
  styleUrls: ['./edit-onetime.component.scss'],
  standalone: false,  // NOSONAR
})

export class EditOnetimeComponent implements OnInit {


  selectedRegions;

  userdropdownTemp: any = [];
  userdropdown: any = [];
  temp2: string;
  userData;
  selected_puser;
  selected_suser;
  selected_region;
  selected_period;
  selected_board;
  selected_duedate;
  selected_sequence = 0;

  temp4;
  temp5;

  temp: string;
  temp3: string;
  regionList: any;
  selectedRegionsTemp: any = [];
  taskData;
  selectedTask;


  periodData;
  boardData;


  successMessage = '';
  errorMessage = '';

  selected_region_Temp_final: any = [];
  userID;
  usertemp: string;
  userInfo: any;
  boardDescription;
  boardTaskID;
  taskDescription;

  boardID;
  tempData;

  selectedRegionTemp = [];


  taskID;

  puserName;
  suserName;
  s_region_flag: boolean = true;

  selected_reg;
  selected_pValue: any;
  selected_sValue: any;
  filteredRegions: any;
  filteredSUserOptions: any;
  filteredUsers: any;

  constructor(private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly boardService: BoardsService,
    private readonly location: Location) {


    // reading from location state
    const data: any = this.location.getState();

    console.info("the data", data);

    this.taskDescription = data.params.TASK;
    this.selected_duedate = data.params.DUE.split(' ')[0] + 'T' + data.params.DUE.split(' ')[1];
    this.selected_sequence = data.params.SEQUENCE;
    this.selected_period = data.params.PERIOD_NAME.trim().split('|')[2];


    let tempUserArr = [];
    let regionsArr = [];
    let keyTemp;

    this.selected_region = [];
    this.selectedRegionTemp = [];

    // populate regions
    Object.keys(data.params).forEach(function (key) {


      if (key == "USER") { // NOSONAR
        tempUserArr = data.params[key].split("|");
      }



      if (data.params[key] != "null" && key != "USER") { // NOSONAR
        regionsArr.push({ "label": data.params[key].split("|")[10], "value": key });
      }

      regionsArr = regionsArr.filter(
        item => item.label != undefined && item.value != undefined // NOSONAR
      );

    });

    console.info("regions array", regionsArr);

    regionsArr?.forEach(element => {


      const obj = { "label": element.label, "value": element.value };
      this.selectedRegionTemp.push(obj);
    });

    this.boardTaskID = data.params.BOARD_TASK_ID;
    this.selected_region = this.selectedRegionTemp;



    this.boardTaskID = data.params.BOARD_TASK_ID;
    console.info("**********************boardTaskID==", this.boardTaskID);


    this.ngxUiLoaderService.start("loader-01");

    //fetch from local-storage
    this.temp = localStorage.getItem('task-data');
    this.taskData = JSON.parse(this.temp);

    //fetch from local-storage
    this.temp3 = localStorage.getItem('region-data');
    this.regionList = JSON.parse(this.temp3);

    this.regionList?.forEach(element => {


      const obj = { "label": element.region, "value": element.region_code };
      this.selectedRegionsTemp.push(obj);
    });

    this.selectedRegions = this.selectedRegionsTemp;
    this.filteredRegions = [...this.selectedRegions];


    //fetch from local-storage
    this.temp2 = localStorage.getItem('users-data');
    this.userData = JSON.parse(this.temp2);


    this.userData?.forEach(element => {


      const obj = { "label": element.firstName + ' ' + element.lastName, "value": element.userPrincipalName };
      this.userdropdownTemp.push(obj);

      console.info(tempUserArr, "tempUserArr")

      if (element.userPrincipalName == tempUserArr[8]) { // NOSONAR
        this.puserName = element.firstName + ' ' + element.lastName;
      }

      if (element.userPrincipalName == tempUserArr[9]) { // NOSONAR
        this.suserName = element.firstName + ' ' + element.lastName;
      }

    });

    this.userdropdown = this.userdropdownTemp;
    this.filteredSUserOptions = [...this.userdropdown];

    // selected user

    this.selected_puser = { "value": parseInt(tempUserArr[8]), "label": this.puserName };
    this.selected_suser = { "value": parseInt(tempUserArr[9]), "label": this.suserName };


    this.temp5 = localStorage.getItem('board-data');
    this.boardData = JSON.parse(this.temp5);


    this.boardService.getboardtaskslist().subscribe(result => {


      if (result?.length > 0) {

        this.tempData = result;
        this.tempData.filter(x => x.boardTaskID == this.boardTaskID).forEach(e => { // NOSONAR

          this.boardID = e.boardID;
          this.taskID = e.taskID;
        });

        this.boardData.filter(x => x.boardID == this.boardID).forEach(element => { // NOSONAR
          this.boardDescription = element.description; 

        });


      }

      else {
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 6500);

      }

      this.ngxUiLoaderService.stop("loader-01");
    });

  }

  ngOnInit(): void {  
    this.flagFunc();
  }

  addtask() {


    console.info("--board", this.boardDescription, "--task", this.taskDescription, "--due date", this.selected_duedate, "--sequence",
      this.selected_sequence, "--puser", this.selected_puser, "--suser", this.selected_suser, "--region", this.selected_region,
      "--updaetd by", this.userID);

    if (this.selected_duedate == undefined) { // NOSONAR
      this.errorMessage = "Please fill in the required fields!";
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);
    }

    else if ((!this.selected_puser && !this.selected_region) || (!this.selected_puser && this.selected_region == '')) { // NOSONAR
      this.errorMessage = "At least a Primary user or a region must be selected.";
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);
    }

    else {


      if (this.selected_puser) {
        this.selected_pValue = this.selected_puser.value;
      }


      if (this.selected_suser) {
        this.selected_sValue = this.selected_suser.value;
      }

      if (this.selected_region) {
        this.selected_region.forEach(element => {

          this.selected_region_Temp_final.push(element.value);
        });

        this.selected_reg = this.selected_region_Temp_final.toString();
      }

      this.addtask_sub()



    }

  }

  addtask_sub() {
    const userData = sessionStorage?.getItem('FGA');
    if (userData) {
      this.userID = JSON.parse(userData)?.user?.userPrincipalName;
    }


    // not undefined
    if (!this.selected_puser) {
      this.selected_puser = null;
    }
    if (!this.selected_suser) {
      this.selected_suser = null;
    }
    if (this.selected_region == '' || !this.selected_region) { // NOSONAR
      this.selected_region = null;
    }





    // format due date

    const due_split = this.selected_duedate.split('T');
    const dueYear = due_split[0].split('-');

    //  mm-dd-yyyy hh:mi
    const due = dueYear[1] + '-' + dueYear[2] + '-' + dueYear[0] + ' ' + due_split[1].substring(0, 5);

    const dataArr = {
      "intuserID": this.userID,
      "boardTaskID": this.boardTaskID,
      "boardID": this.boardID,
      "taskID": this.taskID,
      "due": due,
      "sequence": this.selected_sequence,
      "primaryUser": this.selected_pValue,
      "secondaryUser": this.selected_sValue,
      "regions": this.selected_reg
    }






    this.ngxUiLoaderService.start("loader-01");
    console.info("----this.boardTaskID==", this.boardTaskID);

    console.info("----dataArr==", dataArr);
    this.boardService.saveoneTimeTask(dataArr).subscribe(_result => {
      

      this.successMessage = 'Board Task Saved Successfully!';
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);

      this.ngxUiLoaderService.stop("loader-01");
      // }
    });

    // reset values

    this.selected_region_Temp_final = [];
    this.s_region_flag = true;
  }
  flagFunc() {
    if (this.selected_region == undefined) { // NOSONAR
      this.s_region_flag = true;
    }
    else if (this.selected_region.length == 0) { // NOSONAR
      this.s_region_flag = true;
    }
    else if (this.selected_region.length > 0) { // NOSONAR
      this.s_region_flag = false;
    }

  }
  filterRegions(search: string): void {
    const term = search.toLowerCase();
    this.filteredRegions = this.selectedRegions.filter(region =>
      region.label.toLowerCase().includes(term)
    );
  }
  filterSUsers(searchTerm: string): void {
    const term = searchTerm.toLowerCase();
    this.filteredSUserOptions = this.userdropdown.filter(user =>
      user.label.toLowerCase().includes(term)
    );
  }
  filterUsers(search: string): void {
    const term = search.toLowerCase();
    this.filteredUsers = this.userdropdown.filter(user =>
      user.label.toLowerCase().includes(term)
    );
  }

  compareRegion = (a: any, b: any): boolean => {
    return a && b && a.value == b.value; // NOSONAR
  };
}
